import { Icon } from 'leaflet';

/**
 * Classe pour représenter l'icône utilisé sur la carte
 */
export class MarkerIcon extends Icon {
    constructor(path: string) {
        const ICON_SIZE_X = 25;
        const ICON_SIZE_Y = 41;
        const ICON_ANCHOR_X = 12;
        const ICON_ANCHOR_Y = 41;
        const POP_UP_ANCHOR_X = 1;
        const POP_UP_ANCHOR_Y = -34;
        const SHADOW_SIZE_X = 41;
        const SHADOW_SIZE_Y = 41;

        super({
            iconUrl: path,
            shadowUrl: './img/marker-shadow.png',

            // propriétés du marker
            iconSize: [ICON_SIZE_X, ICON_SIZE_Y],
            iconAnchor: [ICON_ANCHOR_X, ICON_ANCHOR_Y],
            popupAnchor: [POP_UP_ANCHOR_X, POP_UP_ANCHOR_Y],
            shadowSize: [SHADOW_SIZE_X, SHADOW_SIZE_Y]
        });
    }
}